export const translations = {
  ko: {
    // 앱 전체
    appTitle: '올인원 RPMS',
    appSubtitle: '부동산 임대 관리 플랫폼',
    
    // 네비게이션
    overview: '개요',
    platformFeatures: '플랫폼 기능',
    professionalServices: '전문가 서비스',
    aiAssistant: 'AI 부동산 비서',
    contact: '문의하기',
    
    // 플랫폼 기능 하위 메뉴
    propertyPromotion: '매물 홍보 및 관리',
    tenantScreening: '임차인 선별',
    eContract: '전자 계약',
    rentManagement: '임대료 관리',
    maintenance: '유지보수',
    communicationSupport: '소통/지원',
    
    // 전문가 서비스 하위 메뉴
    technicianDirectory: '수리 기사 찾기',
    interiorDesignService: '인테리어 서비스',
    
    // 홈 화면
    heroTitle: '스마트한 부동산 임대 관리의 시작',
    heroSubtitle: '임대인과 임차인을 위한 올인원 관리 플랫폼',
    learnMore: '더 알아보기',
    platformOverview: '플랫폼 개요',
    platformOverviewText: '올인원 RPMS는 부동산 임대 관리의 모든 과정을 하나의 플랫폼에서 해결할 수 있는 혁신적인 솔루션입니다. 매물 홍보부터 계약, 임대료 관리, 유지보수까지 모든 업무를 효율적으로 처리할 수 있습니다.',
    keyBenefits: '주요 장점',
    efficiencyForLandlords: '임대인을 위한 효율성',
    efficiencyForLandlordsDesc: '매물 관리, 임차인 선별, 임대료 수납을 자동화하여 시간과 비용을 절약합니다.',
    convenienceForTenants: '임차인을 위한 편의성',
    convenienceForTenantsDesc: '온라인으로 매물 확인, 계약, 유지보수 요청을 간편하게 처리할 수 있습니다.',
    integratedSystem: '통합 관리 시스템',
    integratedSystemDesc: '모든 임대 관련 업무를 하나의 플랫폼에서 관리하여 업무 효율성을 극대화합니다.',
    
    // 매물 홍보 및 관리
    newPropertyRegistration: '신규 매물 등록',
    propertyName: '매물 이름',
    monthlyRent: '월세',
    keyFeatures: '주요 특징',
    virtualTourUrl: '가상 투어 URL',
    specialRepairProcedures: '콘도별 특별 수리 절차 안내',
    optional: '선택사항',
    generateAIDescription: 'AI 매물 설명 생성',
    generatingDescription: 'AI가 매물 설명을 생성하고 있습니다...',
    aiGeneratedDescription: 'AI 생성 매물 설명',
    finalizeRegistration: '매물 최종 등록',
    myListings: '내 매물 목록',
    noListings: '등록된 매물이 없습니다.',
    manage: '관리',
    propertyMap: '매물 지도',
    loadingMap: '지도를 로딩 중입니다...',
    mapLoadError: '지도를 불러오는 중 오류가 발생했습니다.',
    rentStatus: '임대료/상태',
    
    // 임차인 선별
    newApplications: '신규 임대 신청',
    applicant: '신청자',
    appliedProperty: '신청 매물',
    status: '상태',
    actions: '액션',
    viewDetails: '상세보기',
    approve: '승인',
    reject: '거절',
    reviewing: '검토중',
    approved: '승인됨',
    rejected: '거절됨',
    
    // 전자 계약
    contractTemplates: '계약서 템플릿',
    standardLeaseContract: '표준 주택 임대차 계약서',
    shortTermLeaseContract: '단기 임대 계약서',
    createNewContract: '새 계약서 작성',
    ongoingContracts: '진행 중인 계약',
    viewContract: '계약서 보기',
    awaitingSignature: '서명 대기중',
    contractCompleted: '계약 완료',
    
    // 임대료 관리
    rentStatus: '임대료 현황',
    paid: '납부 완료',
    overdue: '연체',
    partiallyPaid: '부분 납부',
    setupAutoCharge: '자동 청구 설정',
    depositManagement: '보증금 관리',
    totalDeposit: '총 보증금액',
    properties: '개 매물',
    viewSettlementHistory: '정산 내역 보기',
    
    // 유지보수
    newRequests: '새로운 유지보수 요청',
    priority: '우선순위',
    high: '높음',
    medium: '중간',
    low: '낮음',
    new: '신규',
    inProgress: '진행중',
    completed: '완료됨',
    detailsAndAssign: '상세 및 배정',
    findTechnician: '수리 기사 찾기',
    ongoingCompletedWork: '진행 중인/완료된 작업',
    evaluateService: '서비스 평가하기',
    noRequests: '유지보수 요청이 없습니다.',
    
    // 수리 기사 디렉토리
    searchTechnicians: '수리 기사 검색',
    specialty: '전문 분야',
    area: '지역',
    search: '검색',
    allSpecialties: '모든 분야',
    plumbing: '배관',
    electrical: '전기',
    hvac: '냉난방',
    generalRepairs: '일반 수리',
    allAreas: '모든 지역',
    gangnam: '강남',
    seocho: '서초',
    songpa: '송파',
    mapo: '마포',
    serviceArea: '서비스 가능 지역',
    services: '제공 서비스',
    averageRating: '평균 평점',
    price: '가격',
    contactTechnician: '기사에게 문의',
    noSearchResults: '검색 결과가 없습니다.',
    
    // 인테리어 서비스
    searchInteriorDesigners: '인테리어 전문가 검색',
    style: '스타일',
    budgetRange: '예산 범위',
    allStyles: '모든 스타일',
    modern: '모던',
    minimalist: '미니멀리스트',
    classic: '클래식',
    scandinavian: '스칸디나비안',
    allBudgets: '모든 예산',
    budget1: 'Under ₱300,000',
    budget2: '₱300,000-₱800,000',
    budget3: '₱800,000-₱1,500,000',
    budget4: 'Over ₱1,500,000',
    specialtyStyles: '전문 스타일',
    budget: '예산',
    portfolio: '포트폴리오',
    requestConsultation: '상담 요청',
    
    // 소통 및 지원
    platformSupportFeatures: '플랫폼 지원 기능',
    enhancedSecurity: '강화된 보안',
    enhancedSecurityDesc: '모든 데이터는 암호화되어 안전하게 보호됩니다.',
    smoothCommunication: '원활한 소통',
    smoothCommunicationDesc: '임대인과 임차인 간 실시간 메시지 기능을 제공합니다.',
    accountingReporting: '회계 리포팅',
    accountingReportingDesc: '임대 수익과 비용을 자동으로 정리하여 리포트를 생성합니다.',
    multiUserManagement: '다중 사용자 관리',
    multiUserManagementDesc: '여러 관리자가 권한을 나누어 효율적으로 관리할 수 있습니다.',
    mobileAppSupport: '모바일 앱 지원',
    mobileAppSupportDesc: '언제 어디서나 모바일로 편리하게 관리할 수 있습니다.',
    virtualTourSupport: '가상 투어 지원',
    virtualTourSupportDesc: '360도 가상 투어로 매물을 생생하게 확인할 수 있습니다.',
    
    // AI 부동산 비서
    aiAssistantTitle: 'AI 부동산 비서',
    askAnything: '부동산 관련 궁금한 점을 물어보세요',
    thinking: 'AI가 답변을 생각 중입니다...',
    send: '전송',
    viewOriginal: '원문 보기',
    viewTranslation: '번역 보기',
    
    // 문의하기
    contactUs: '문의하기',
    name: '이름',
    email: '이메일',
    message: '메시지',
    submitInquiry: '문의 제출',
    inquirySubmitted: '문의가 성공적으로 제출되었습니다.',
    
    // Footer
    copyright: '© 2024 올인원 RPMS. All rights reserved.',
    aiContentNotice: 'AI로 생성된 콘텐츠는 부정확할 수 있으니 중요한 결정에 참고하실 때는 전문가와 상담하시기 바랍니다.',
    projectNotice: '이 프로젝트는 데모용이며 실제 서비스가 아닙니다.',
    
    // 공통
    loading: '로딩 중...',
    error: '오류가 발생했습니다.',
    retry: '다시 시도',
    cancel: '취소',
    save: '저장',
    delete: '삭제',
    edit: '편집',
    close: '닫기',
    back: '뒤로',
    next: '다음',
    previous: '이전',
    confirm: '확인',
    selectLanguage: '언어 선택',
  },
  en: {
    // App-wide
    appTitle: 'All-in-One RPMS',
    appSubtitle: 'Real Estate Property Management Platform',
    
    // Navigation
    overview: 'Overview',
    platformFeatures: 'Platform Features',
    professionalServices: 'Professional Services',
    aiAssistant: 'AI Real Estate Assistant',
    contact: 'Contact',
    
    // Platform Features submenu
    propertyPromotion: 'Property Promotion',
    tenantScreening: 'Tenant Screening',
    eContract: 'E-Contract',
    rentManagement: 'Rent Management',
    maintenance: 'Maintenance',
    communicationSupport: 'Communication/Support',
    
    // Professional Services submenu
    technicianDirectory: 'Find Technicians',
    interiorDesignService: 'Interior Design Service',
    
    // Home screen
    heroTitle: 'Smart Real Estate Rental Management',
    heroSubtitle: 'All-in-one management platform for landlords and tenants',
    learnMore: 'Learn More',
    platformOverview: 'Platform Overview',
    platformOverviewText: 'All-in-One RPMS is an innovative solution that handles all aspects of real estate rental management on a single platform. From property promotion to contracts, rent management, and maintenance, you can efficiently handle all tasks.',
    keyBenefits: 'Key Benefits',
    efficiencyForLandlords: 'Efficiency for Landlords',
    efficiencyForLandlordsDesc: 'Save time and money by automating property management, tenant screening, and rent collection.',
    convenienceForTenants: 'Convenience for Tenants',
    convenienceForTenantsDesc: 'Easily check properties, sign contracts, and request maintenance online.',
    integratedSystem: 'Integrated Management System',
    integratedSystemDesc: 'Maximize efficiency by managing all rental-related tasks on one platform.',
    
    // Property Promotion
    newPropertyRegistration: 'New Property Registration',
    propertyName: 'Property Name',
    monthlyRent: 'Monthly Rent',
    keyFeatures: 'Key Features',
    virtualTourUrl: 'Virtual Tour URL',
    specialRepairProcedures: 'Special Repair Procedures by Condo',
    optional: 'Optional',
    generateAIDescription: 'Generate AI Description',
    generatingDescription: 'AI is generating property description...',
    aiGeneratedDescription: 'AI Generated Description',
    finalizeRegistration: 'Finalize Registration',
    myListings: 'My Listings',
    noListings: 'No properties registered.',
    manage: 'Manage',
    propertyMap: 'Property Map',
    loadingMap: 'Loading map...',
    mapLoadError: 'Error loading map.',
    rentStatus: 'Rent/Status',
    
    // Tenant Screening
    newApplications: 'New Rental Applications',
    applicant: 'Applicant',
    appliedProperty: 'Applied Property',
    status: 'Status',
    actions: 'Actions',
    viewDetails: 'View Details',
    approve: 'Approve',
    reject: 'Reject',
    reviewing: 'Reviewing',
    approved: 'Approved',
    rejected: 'Rejected',
    
    // E-Contract
    contractTemplates: 'Contract Templates',
    standardLeaseContract: 'Standard Residential Lease Agreement',
    shortTermLeaseContract: 'Short-term Lease Agreement',
    createNewContract: 'Create New Contract',
    ongoingContracts: 'Ongoing Contracts',
    viewContract: 'View Contract',
    awaitingSignature: 'Awaiting Signature',
    contractCompleted: 'Contract Completed',
    
    // Rent Management
    rentStatus: 'Rent Status',
    paid: 'Paid',
    overdue: 'Overdue',
    partiallyPaid: 'Partially Paid',
    setupAutoCharge: 'Setup Auto Charge',
    depositManagement: 'Deposit Management',
    totalDeposit: 'Total Deposit',
    properties: 'properties',
    viewSettlementHistory: 'View Settlement History',
    
    // Maintenance
    newRequests: 'New Maintenance Requests',
    priority: 'Priority',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    new: 'New',
    inProgress: 'In Progress',
    completed: 'Completed',
    detailsAndAssign: 'Details & Assign',
    findTechnician: 'Find Technician',
    ongoingCompletedWork: 'Ongoing/Completed Work',
    evaluateService: 'Evaluate Service',
    noRequests: 'No maintenance requests.',
    
    // Technician Directory
    searchTechnicians: 'Search Technicians',
    specialty: 'Specialty',
    area: 'Area',
    search: 'Search',
    allSpecialties: 'All Specialties',
    plumbing: 'Plumbing',
    electrical: 'Electrical',
    hvac: 'HVAC',
    generalRepairs: 'General Repairs',
    allAreas: 'All Areas',
    gangnam: 'Gangnam',
    seocho: 'Seocho',
    songpa: 'Songpa',
    mapo: 'Mapo',
    serviceArea: 'Service Area',
    services: 'Services',
    averageRating: 'Average Rating',
    price: 'Price',
    contactTechnician: 'Contact Technician',
    noSearchResults: 'No search results.',
    
    // Interior Design Service
    searchInteriorDesigners: 'Search Interior Designers',
    style: 'Style',
    budgetRange: 'Budget Range',
    allStyles: 'All Styles',
    modern: 'Modern',
    minimalist: 'Minimalist',
    classic: 'Classic',
    scandinavian: 'Scandinavian',
    allBudgets: 'All Budgets',
    budget1: 'Under ₱300,000',
    budget2: '₱300,000-₱800,000',
    budget3: '₱800,000-₱1,500,000',
    budget4: 'Over ₱1,500,000',
    specialtyStyles: 'Specialty Styles',
    budget: 'Budget',
    portfolio: 'Portfolio',
    requestConsultation: 'Request Consultation',
    
    // Communication & Support
    platformSupportFeatures: 'Platform Support Features',
    enhancedSecurity: 'Enhanced Security',
    enhancedSecurityDesc: 'All data is encrypted and securely protected.',
    smoothCommunication: 'Smooth Communication',
    smoothCommunicationDesc: 'Real-time messaging between landlords and tenants.',
    accountingReporting: 'Accounting Reporting',
    accountingReportingDesc: 'Automatically organize rental income and expenses to generate reports.',
    multiUserManagement: 'Multi-user Management',
    multiUserManagementDesc: 'Multiple managers can efficiently manage with divided permissions.',
    mobileAppSupport: 'Mobile App Support',
    mobileAppSupportDesc: 'Manage conveniently on mobile anytime, anywhere.',
    virtualTourSupport: 'Virtual Tour Support',
    virtualTourSupportDesc: 'View properties vividly with 360-degree virtual tours.',
    
    // AI Real Estate Assistant
    aiAssistantTitle: 'AI Real Estate Assistant',
    askAnything: 'Ask anything about real estate',
    thinking: 'AI is thinking of an answer...',
    send: 'Send',
    viewOriginal: 'View Original',
    viewTranslation: 'View Translation',
    
    // Contact
    contactUs: 'Contact Us',
    name: 'Name',
    email: 'Email',
    message: 'Message',
    submitInquiry: 'Submit Inquiry',
    inquirySubmitted: 'Your inquiry has been successfully submitted.',
    
    // Footer
    copyright: '© 2024 All-in-One RPMS. All rights reserved.',
    aiContentNotice: 'AI-generated content may be inaccurate. Please consult with professionals for important decisions.',
    projectNotice: 'This project is for demo purposes and is not an actual service.',
    
    // Common
    loading: 'Loading...',
    error: 'An error occurred.',
    retry: 'Retry',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    confirm: 'Confirm',
    selectLanguage: 'Select Language',
  },
  zh: {
    // 应用程序全局
    appTitle: '一体化RPMS',
    appSubtitle: '房地产租赁管理平台',
    
    // 导航
    overview: '概览',
    platformFeatures: '平台功能',
    professionalServices: '专业服务',
    aiAssistant: 'AI房地产助手',
    contact: '联系我们',
    
    // 平台功能子菜单
    propertyPromotion: '房源推广与管理',
    tenantScreening: '租户筛选',
    eContract: '电子合同',
    rentManagement: '租金管理',
    maintenance: '维护保养',
    communicationSupport: '沟通/支持',
    
    // 专业服务子菜单
    technicianDirectory: '寻找维修工',
    interiorDesignService: '室内设计服务',
    
    // 主页
    heroTitle: '智能房地产租赁管理的开始',
    heroSubtitle: '为房东和租户提供的一体化管理平台',
    learnMore: '了解更多',
    platformOverview: '平台概览',
    platformOverviewText: '一体化RPMS是一个创新的解决方案，可以在一个平台上解决房地产租赁管理的所有过程。从房源推广到合同、租金管理、维护保养，您可以高效处理所有任务。',
    keyBenefits: '主要优势',
    efficiencyForLandlords: '为房东提高效率',
    efficiencyForLandlordsDesc: '通过自动化房源管理、租户筛选和租金收取来节省时间和成本。',
    convenienceForTenants: '为租户提供便利',
    convenienceForTenantsDesc: '可以在线轻松查看房源、签订合同和请求维修。',
    integratedSystem: '综合管理系统',
    integratedSystemDesc: '通过在一个平台上管理所有租赁相关任务来最大化效率。',
    
    // 房源推广
    newPropertyRegistration: '新房源登记',
    propertyName: '房源名称',
    monthlyRent: '月租',
    keyFeatures: '主要特征',
    virtualTourUrl: '虚拟游览URL',
    specialRepairProcedures: '公寓特殊维修程序指南',
    optional: '可选',
    generateAIDescription: '生成AI描述',
    generatingDescription: 'AI正在生成房源描述...',
    aiGeneratedDescription: 'AI生成的房源描述',
    finalizeRegistration: '完成登记',
    myListings: '我的房源',
    noListings: '没有登记的房源。',
    manage: '管理',
    propertyMap: '房源地图',
    loadingMap: '正在加载地图...',
    mapLoadError: '加载地图时出错。',
    rentStatus: '租金/状态',
    
    // 租户筛选
    newApplications: '新租赁申请',
    applicant: '申请人',
    appliedProperty: '申请房源',
    status: '状态',
    actions: '操作',
    viewDetails: '查看详情',
    approve: '批准',
    reject: '拒绝',
    reviewing: '审查中',
    approved: '已批准',
    rejected: '已拒绝',
    
    // 电子合同
    contractTemplates: '合同模板',
    standardLeaseContract: '标准住宅租赁合同',
    shortTermLeaseContract: '短期租赁合同',
    createNewContract: '创建新合同',
    ongoingContracts: '进行中的合同',
    viewContract: '查看合同',
    awaitingSignature: '等待签名',
    contractCompleted: '合同完成',
    
    // 租金管理
    rentStatus: '租金状态',
    paid: '已支付',
    overdue: '逾期',
    partiallyPaid: '部分支付',
    setupAutoCharge: '设置自动收费',
    depositManagement: '押金管理',
    totalDeposit: '总押金',
    properties: '个房源',
    viewSettlementHistory: '查看结算历史',
    
    // 维护保养
    newRequests: '新维修请求',
    priority: '优先级',
    high: '高',
    medium: '中',
    low: '低',
    new: '新',
    inProgress: '进行中',
    completed: '已完成',
    detailsAndAssign: '详情和分配',
    findTechnician: '寻找维修工',
    ongoingCompletedWork: '进行中/已完成的工作',
    evaluateService: '评估服务',
    noRequests: '没有维修请求。',
    
    // 维修工目录
    searchTechnicians: '搜索维修工',
    specialty: '专业',
    area: '地区',
    search: '搜索',
    allSpecialties: '所有专业',
    plumbing: '管道',
    electrical: '电气',
    hvac: '暖通空调',
    generalRepairs: '一般维修',
    allAreas: '所有地区',
    gangnam: '江南',
    seocho: '瑞草',
    songpa: '松坡',
    mapo: '麻浦',
    serviceArea: '服务区域',
    services: '提供服务',
    averageRating: '平均评分',
    price: '价格',
    contactTechnician: '联系维修工',
    noSearchResults: '没有搜索结果。',
    
    // 室内设计服务
    searchInteriorDesigners: '搜索室内设计师',
    style: '风格',
    budgetRange: '预算范围',
    allStyles: '所有风格',
    modern: '现代',
    minimalist: '极简主义',
    classic: '经典',
    scandinavian: '斯堪的纳维亚',
    allBudgets: '所有预算',
    budget1: '₱300,000以下',
    budget2: '₱300,000-₱800,000',
    budget3: '₱800,000-₱1,500,000',
    budget4: '₱1,500,000以上',
    specialtyStyles: '专业风格',
    budget: '预算',
    portfolio: '作品集',
    requestConsultation: '请求咨询',
    
    // 沟通与支持
    platformSupportFeatures: '平台支持功能',
    enhancedSecurity: '增强安全性',
    enhancedSecurityDesc: '所有数据都经过加密并安全保护。',
    smoothCommunication: '顺畅沟通',
    smoothCommunicationDesc: '提供房东和租户之间的实时消息功能。',
    accountingReporting: '会计报告',
    accountingReportingDesc: '自动整理租金收入和支出生成报告。',
    multiUserManagement: '多用户管理',
    multiUserManagementDesc: '多个管理员可以分配权限高效管理。',
    mobileAppSupport: '移动应用支持',
    mobileAppSupportDesc: '随时随地通过移动设备方便管理。',
    virtualTourSupport: '虚拟游览支持',
    virtualTourSupportDesc: '通过360度虚拟游览生动查看房源。',
    
    // AI房地产助手
    aiAssistantTitle: 'AI房地产助手',
    askAnything: '询问任何房地产相关问题',
    thinking: 'AI正在思考答案...',
    send: '发送',
    viewOriginal: '查看原文',
    viewTranslation: '查看翻译',
    
    // 联系我们
    contactUs: '联系我们',
    name: '姓名',
    email: '电子邮件',
    message: '消息',
    submitInquiry: '提交询问',
    inquirySubmitted: '您的询问已成功提交。',
    
    // 页脚
    copyright: '© 2024 一体化RPMS。保留所有权利。',
    aiContentNotice: 'AI生成的内容可能不准确，在做重要决定时请咨询专业人士。',
    projectNotice: '此项目仅供演示，不是实际服务。',
    
    // 通用
    loading: '加载中...',
    error: '发生错误。',
    retry: '重试',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    close: '关闭',
    back: '返回',
    next: '下一个',
    previous: '上一个',
    confirm: '确认',
    selectLanguage: '选择语言',
  },
  ja: {
    // アプリ全体
    appTitle: 'オールインワンRPMS',
    appSubtitle: '不動産賃貸管理プラットフォーム',
    
    // ナビゲーション
    overview: '概要',
    platformFeatures: 'プラットフォーム機能',
    professionalServices: '専門サービス',
    aiAssistant: 'AI不動産アシスタント',
    contact: 'お問い合わせ',
    
    // プラットフォーム機能サブメニュー
    propertyPromotion: '物件宣伝・管理',
    tenantScreening: 'テナント選別',
    eContract: '電子契約',
    rentManagement: '賃料管理',
    maintenance: 'メンテナンス',
    communicationSupport: 'コミュニケーション/サポート',
    
    // 専門サービスサブメニュー
    technicianDirectory: '修理業者を探す',
    interiorDesignService: 'インテリアサービス',
    
    // ホーム画面
    heroTitle: 'スマートな不動産賃貸管理の始まり',
    heroSubtitle: '大家とテナントのためのオールインワン管理プラットフォーム',
    learnMore: '詳しく見る',
    platformOverview: 'プラットフォーム概要',
    platformOverviewText: 'オールインワンRPMSは、不動産賃貸管理のすべてのプロセスを1つのプラットフォームで解決できる革新的なソリューションです。物件の宣伝から契約、賃料管理、メンテナンスまで、すべての業務を効率的に処理できます。',
    keyBenefits: '主な利点',
    efficiencyForLandlords: '大家のための効率性',
    efficiencyForLandlordsDesc: '物件管理、テナント選別、賃料回収を自動化し、時間とコストを節約します。',
    convenienceForTenants: 'テナントのための利便性',
    convenienceForTenantsDesc: 'オンラインで物件確認、契約、メンテナンス要請を簡単に処理できます。',
    integratedSystem: '統合管理システム',
    integratedSystemDesc: 'すべての賃貸関連業務を1つのプラットフォームで管理し、業務効率を最大化します。',
    
    // 物件宣伝
    newPropertyRegistration: '新規物件登録',
    propertyName: '物件名',
    monthlyRent: '月額賃料',
    keyFeatures: '主な特徴',
    virtualTourUrl: 'バーチャルツアーURL',
    specialRepairProcedures: 'コンドミニアム別特別修理手順案内',
    optional: 'オプション',
    generateAIDescription: 'AI物件説明生成',
    generatingDescription: 'AIが物件説明を生成しています...',
    aiGeneratedDescription: 'AI生成物件説明',
    finalizeRegistration: '物件最終登録',
    myListings: '私の物件リスト',
    noListings: '登録された物件がありません。',
    manage: '管理',
    propertyMap: '物件地図',
    loadingMap: '地図を読み込んでいます...',
    mapLoadError: '地図の読み込み中にエラーが発生しました。',
    rentStatus: '賃料/状態',
    
    // テナント選別
    newApplications: '新規賃貸申請',
    applicant: '申請者',
    appliedProperty: '申請物件',
    status: '状態',
    actions: 'アクション',
    viewDetails: '詳細を見る',
    approve: '承認',
    reject: '拒否',
    reviewing: '検討中',
    approved: '承認済み',
    rejected: '拒否済み',
    
    // 電子契約
    contractTemplates: '契約書テンプレート',
    standardLeaseContract: '標準住宅賃貸借契約書',
    shortTermLeaseContract: '短期賃貸契約書',
    createNewContract: '新しい契約書を作成',
    ongoingContracts: '進行中の契約',
    viewContract: '契約書を見る',
    awaitingSignature: '署名待ち',
    contractCompleted: '契約完了',
    
    // 賃料管理
    rentStatus: '賃料状況',
    paid: '支払い完了',
    overdue: '延滞',
    partiallyPaid: '部分支払い',
    setupAutoCharge: '自動請求設定',
    depositManagement: '保証金管理',
    totalDeposit: '総保証金額',
    properties: '物件',
    viewSettlementHistory: '精算履歴を見る',
    
    // メンテナンス
    newRequests: '新しいメンテナンス要請',
    priority: '優先順位',
    high: '高',
    medium: '中',
    low: '低',
    new: '新規',
    inProgress: '進行中',
    completed: '完了',
    detailsAndAssign: '詳細と割り当て',
    findTechnician: '修理業者を探す',
    ongoingCompletedWork: '進行中/完了した作業',
    evaluateService: 'サービスを評価',
    noRequests: 'メンテナンス要請がありません。',
    
    // 修理業者ディレクトリ
    searchTechnicians: '修理業者検索',
    specialty: '専門分野',
    area: '地域',
    search: '検索',
    allSpecialties: 'すべての分野',
    plumbing: '配管',
    electrical: '電気',
    hvac: '冷暖房',
    generalRepairs: '一般修理',
    allAreas: 'すべての地域',
    gangnam: '江南',
    seocho: '瑞草',
    songpa: '松坡',
    mapo: '麻浦',
    serviceArea: 'サービス可能地域',
    services: '提供サービス',
    averageRating: '平均評価',
    price: '価格',
    contactTechnician: '業者に問い合わせ',
    noSearchResults: '検索結果がありません。',
    
    // インテリアサービス
    searchInteriorDesigners: 'インテリア専門家検索',
    style: 'スタイル',
    budgetRange: '予算範囲',
    allStyles: 'すべてのスタイル',
    modern: 'モダン',
    minimalist: 'ミニマリスト',
    classic: 'クラシック',
    scandinavian: 'スカンジナビアン',
    allBudgets: 'すべての予算',
    budget1: '₱300,000以下',
    budget2: '₱300,000〜₱800,000',
    budget3: '₱800,000〜₱1,500,000',
    budget4: '₱1,500,000以上',
    specialtyStyles: '専門スタイル',
    budget: '予算',
    portfolio: 'ポートフォリオ',
    requestConsultation: '相談を依頼',
    
    // コミュニケーションとサポート
    platformSupportFeatures: 'プラットフォームサポート機能',
    enhancedSecurity: '強化されたセキュリティ',
    enhancedSecurityDesc: 'すべてのデータは暗号化され、安全に保護されています。',
    smoothCommunication: 'スムーズなコミュニケーション',
    smoothCommunicationDesc: '大家とテナント間のリアルタイムメッセージ機能を提供します。',
    accountingReporting: '会計レポート',
    accountingReportingDesc: '賃貸収益と費用を自動的に整理してレポートを生成します。',
    multiUserManagement: 'マルチユーザー管理',
    multiUserManagementDesc: '複数の管理者が権限を分けて効率的に管理できます。',
    mobileAppSupport: 'モバイルアプリサポート',
    mobileAppSupportDesc: 'いつでもどこでもモバイルで便利に管理できます。',
    virtualTourSupport: 'バーチャルツアーサポート',
    virtualTourSupportDesc: '360度バーチャルツアーで物件を生き生きと確認できます。',
    
    // AI不動産アシスタント
    aiAssistantTitle: 'AI不動産アシスタント',
    askAnything: '不動産に関する質問をしてください',
    thinking: 'AIが回答を考えています...',
    send: '送信',
    viewOriginal: '原文を見る',
    viewTranslation: '翻訳を見る',
    
    // お問い合わせ
    contactUs: 'お問い合わせ',
    name: '名前',
    email: 'メール',
    message: 'メッセージ',
    submitInquiry: 'お問い合わせを送信',
    inquirySubmitted: 'お問い合わせが正常に送信されました。',
    
    // フッター
    copyright: '© 2024 オールインワンRPMS. All rights reserved.',
    aiContentNotice: 'AIによって生成されたコンテンツは不正確な場合があるため、重要な決定を行う際は専門家にご相談ください。',
    projectNotice: 'このプロジェクトはデモ用であり、実際のサービスではありません。',
    
    // 共通
    loading: '読み込み中...',
    error: 'エラーが発生しました。',
    retry: '再試行',
    cancel: 'キャンセル',
    save: '保存',
    delete: '削除',
    edit: '編集',
    close: '閉じる',
    back: '戻る',
    next: '次へ',
    previous: '前へ',
    confirm: '確認',
    selectLanguage: '言語を選択',
  },
};
